export const LocalFormActionTypes = {
  MODIFY_LOCAL_FORM: "MODIFY_LOCAL_FORM",
  RESET_LOCAL_FORM: "RESET_LOCAL_FORM",
};
